<!-- Translated: no -->
<template>
  <div :class="'campaign-code ' + cssStateClasses">

    <div v-if="isValid === CODE_STATE.NOT_TRIED || isValid === CODE_STATE.CHECKING || isValid === CODE_STATE.INVALID">
      <p>Har du en kampanjkod? Använd den här.</p>

      <div class="code-wrapper">
        
        <div>
          <input :class="{error: !!errorMessage}" type="text" autocomplete="off" v-model="code" @keyup.enter="tryCode" />
        </div>
        <div>
          <Loading :text="'Kontrollerar kampanjkod ' + code + '...'" :show="isValid === CODE_STATE.CHECKING" :static="true"></Loading>
          <button class="small" :disabled="!code" @click="tryCode" v-if="isValid !== CODE_STATE.CHECKING">Använd</button>
        </div>
      </div>

      <p v-if="errorMessage" :class="'error-message'">{{errorMessage}}</p>
    </div>

    <div class="code-wrapper" v-if="isValid === CODE_STATE.VALID || isValid === CODE_STATE.REMOVING">
      <div class="code-wrapper-inner">
        <div style="padding-right: 1em;">
          <p style="margin: 1em 0;">Bokar med kampanjkod: <b>{{ code }}</b></p>
        </div>
        <div>
          <button class="small white border" @click="removeCode">Ta bort</button>
        </div>
      </div>
      <div v-if="requiresExtraInput" style="width:100%; max-width: 580px;">
        <p v-html="requiresExtraInputMessage"></p>
        <input style="width:100%; max-width: 300px;" :class="{error: !!errorMessage}" type="text" autocomplete="off" v-model="extraInput" @keyup="updateExtraInfo" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import Modal from '@/components/components/Modal';
import Login from '@/components/payments/Login';
import Loading from '@/components/components/Loading';

import API from '@/classes/API';

const CODE_STATE = {
  NOT_TRIED: 0,
  CHECKING: 1,
  INVALID: 2,
  VALID: 3,
  REMOVING: 4,
};

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    Login,
    Loading,
  },
  data() {
    return {
      code: '',
      isValid: CODE_STATE.NOT_TRIED,
      errorMessage: '',
      requiresExtraInput: true,
      requiresExtraInputMessage: '',
      extraInput: '',
    };
  },
  async mounted() {
    this.code = this.$store.state.cart.pincode || this.$store.state.cart.campaignCode;

    await this.reapply();
  },
  computed: {
    ...mapGetters([
      'loggedIn',
    ]),
    cssStateClasses() {
      return ' ' + // eslint-disable-line
        (this.isValid === CODE_STATE.NOT_TRIED ? ' ' : '') + // eslint-disable-line
        (this.isValid === CODE_STATE.CHECKING ? ' disabled' : '') + // eslint-disable-line
        (this.isValid === CODE_STATE.INVALID ? ' invalid' : '') + // eslint-disable-line
        (this.isValid === CODE_STATE.VALID ? ' valid' : '') + // eslint-disable-line
        (this.isValid === CODE_STATE.REMOVING ? ' disabled' : ''); // eslint-disable-line
    },
    CODE_STATE() {
      return CODE_STATE;
    },
  },
  methods: {
    ...mapMutations([
      'updateCampaignCode',
      'updateCampaignCodeExtraInfo',
    ]),
    async fetchCodeAndUpdateCart(lCode, forceEmptyCode = false) {
      this.errorMessage = '';
      this.loading = true;

      const endpoint = forceEmptyCode ? 'remove-campaign-code' : 'apply-campaign-code';

      let data;
      let success;
      let message;
      let campaign_code; // eslint-disable-line
      let requires_extra_input; // eslint-disable-line
      let requires_extra_input_message; // eslint-disable-line

      try {
        ({ data, success, message, campaign_code,
          requires_extra_input, requires_extra_input_message } =
          await API.frontendHelper(endpoint, {
            cart: this.$store.state.cart,
            code: lCode,
          }));
      } catch (error) {
        // Handle error: set error message, update state, etc.
        this.errorMessage = 'Vi kunde inte kontrollera koden just nu. Försök igen eller kontakta gästservice.';
        this.isValid = CODE_STATE.NOT_TRIED;
        return;
      }

      this.loading = false;
      this.requiresExtraInput = requires_extra_input; // eslint-disable-line
      this.requiresExtraInputMessage = requires_extra_input_message; // eslint-disable-line

      if (success) {
        const accomodationPrices = data.accomodations;
        const addonPrices = data.addons;
        const skipassPrices = data.skipasses;
        const rentalPrices = data.rentals;

        const localCart = this.$store.state.cart;

        const rentalProductTypes = ['products', 'addons'];

        // eslint-disable-next-line
        for (let i in localCart.accomodations) {
          const poolLid = localCart.accomodations[i].poolLid;
          const unitLid = localCart.accomodations[i].unitLid;
          const combinedId = `${poolLid}.${unitLid}`;

          localCart.accomodations[i].discountedPrice = Number.isInteger(accomodationPrices[combinedId]) ? accomodationPrices[combinedId] : null; // eslint-disable-line
        }
        // eslint-enable

        // eslint-disable-next-line
        for (let i in localCart.addons) {
          const poolLid = localCart.addons[i].lid;

          localCart.addons[i].discountedPrice = Number.isInteger(addonPrices[poolLid]) ? addonPrices[poolLid] : null; // eslint-disable-line
        }
        // eslint-enable

        // eslint-disable-next-line
        for (let i in localCart.skipasses) {
          const poolLid = localCart.skipasses[i].poolLid;

          if (localCart.skipasses[i].type && localCart.skipasses[i].type === 'SKIPASS-ACCO') {
            localCart.skipasses[i].discountedPrices = skipassPrices || {};
          } else {
            localCart.skipasses[i].discountedPrice = Number.isInteger(skipassPrices[poolLid]) ? skipassPrices[poolLid] : null; // eslint-disable-line
          }
        }
        // eslint-enable

        // eslint-disable-next-line
        for (let i in localCart.rentals) {
          const age = localCart.rentals[i].age;
          const days = localCart.rentals[i].days;

          // eslint-disable-next-line
          for (let iTyp in rentalProductTypes) {
            const typ = rentalProductTypes[iTyp];

            // eslint-disable-next-line
            for (var ii in localCart.rentals[i][typ]) {
              const poolLid = localCart.rentals[i][typ][ii].pool_lid;

              localCart.rentals[i][typ][ii].discountedPrice = Number.isInteger(rentalPrices[poolLid + '.' + age + '.' + days]) ? rentalPrices[poolLid + '.' + age + '.' + days] : null; // eslint-disable-line

              if (forceEmptyCode) {
                localCart.rentals[i][typ][ii].discountedPrice = null;
              }
            }
          }
        }
        // eslint-enable

        console.log(localCart.skipasses);

        localCart.campaignCode = this.code;
        localCart.pincode = '';

        if (typeof campaign_code === 'undefined' || !campaign_code) { // eslint-disable-line
          localCart.pincode = this.code;
          localCart.campaignCode = '';
        }

        this.isValid = CODE_STATE.VALID;
        // setCart(localCart);
        this.errorMessage = '';

        if (forceEmptyCode) {
          this.isValid = CODE_STATE.NOT_TRIED;
          this.code = '';
          this.updateCampaignCode({
            pincode: '',
            campaignCode: '',
            codeRequiresExtraInfo: false,
            codeExtraInfo: '',
            skipasses: localCart.skipasses,
            rentals: localCart.rentals,
            accomodations: localCart.accomodations,
            addons: localCart.addons,
          });
        } else {
          this.updateCampaignCode({
            pincode: localCart.pincode,
            campaignCode: localCart.campaignCode,
            codeRequiresExtraInfo: this.requiresExtraInput,
            codeExtraInfo: '',
            skipasses: localCart.skipasses,
            rentals: localCart.rentals,
            accomodations: localCart.accomodations,
            addons: localCart.addons,
          });
        }
      } else {
        const localCart = this.$store.state.cart;

        this.isValid = CODE_STATE.INVALID;
        this.errorMessage = message;

        this.updateCampaignCode({
          pincode: '',
          campaignCode: '',
          codeRequiresExtraInfo: false,
          codeExtraInfo: '',
          skipasses: localCart.skipasses,
          rentals: localCart.rentals,
          accomodations: localCart.accomodations,
          addons: localCart.addons,
        });

        if (forceEmptyCode) {
          this.isValid = CODE_STATE.VALID;

          this.updateCampaignCode({
            pincode: '',
            campaignCode: '',
            codeRequiresExtraInfo: false,
            codeExtraInfo: '',
            skipasses: localCart.skipasses,
            rentals: localCart.rentals,
            accomodations: localCart.accomodations,
            addons: localCart.addons,
          });
        }
      }
    },
    updateExtraInfo() {
      this.updateCampaignCodeExtraInfo({
        codeExtraInfo: this.extraInput,
      });
    },
    async tryCode() {
      this.isValid = CODE_STATE.CHECKING;
      this.code = (this.code || '').toUpperCase();

      await this.fetchCodeAndUpdateCart(this.code, false);
    },
    async removeCode() {
      this.isValid = CODE_STATE.REMOVING;

      await this.fetchCodeAndUpdateCart('', true);
    },
    async reapply() {
      // TODO
      if (this.code) {
        await this.tryCode();
      }
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

input
  input()
  margin-right: 1em;
  width: 15em;
  font-size: 16px;
  line-height: 1.5em;

.code-wrapper
  display: flex;
  justify-content: flex-end
  align-items: center
  flex-wrap: wrap
  .code-wrapper-inner
    width 100%
    display: flex;
    justify-content: flex-end
    align-items: center
    flex-wrap: wrap

.error-message
  margin-top: 1em;

.disabled {
  pointer-events: none;
  opacity: 0.3;
  transition: all 0.2s;
}

</style>



// WEBPACK FOOTER //
// CheckoutCodeModal.vue?6676853c